import { render, staticRenderFns } from "./RedPacketIndex.vue?vue&type=template&id=6e124acc&scoped=true"
import script from "./RedPacketIndex.vue?vue&type=script&lang=js"
export * from "./RedPacketIndex.vue?vue&type=script&lang=js"
import style0 from "./RedPacketIndex.vue?vue&type=style&index=0&id=6e124acc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e124acc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e124acc')) {
      api.createRecord('6e124acc', component.options)
    } else {
      api.reload('6e124acc', component.options)
    }
    module.hot.accept("./RedPacketIndex.vue?vue&type=template&id=6e124acc&scoped=true", function () {
      api.rerender('6e124acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/red_packet/RedPacketIndex.vue"
export default component.exports